import { cloneDeep, get, set } from "lodash";
import * as React from "react";
import NumberFormat, { NumberFormatProps } from "react-number-format";
import { Input, InputProps } from ".";

type Props = InputProps & NumberFormatProps;

export default function DollarInputV2(props: Props) {
  return (
    <NumberFormat
      // @ts-ignore
      customInput={Input}
      prefix="$"
      thousandSeparator={true}
      decimalScale={2}
      fixedDecimalScale={true}
      isNumericString
      onValueChange={(e) => {
        props.name &&
          props.formik &&
          get(props.formik.values, props.name) !== (e.floatValue ?? "") &&
          props.formik.setFieldValue(props.name, e.floatValue ?? "");
      }}
      value={(props.name && get(props.formik?.values, props.name)) ?? ""}
      {...props}
    />
  );
}
